import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { RootGate } from './RootGate';

// Observability: no-op when VITE_SENTRY_DSN is empty/undefined. The DSN is wired
// as a Docker build arg + render.yaml by the backend/config side.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || undefined,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
});

const errorFallback = (
  <div
    role="alert"
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    }}
  >
    <div style={{ maxWidth: 480 }}>
      <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
      <p style={{ lineHeight: 1.6, color: '#616161' }}>
        An unexpected error occurred. Please reload the page. If the problem
        persists, contact support.
      </p>
    </div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={errorFallback}>
      <RootGate />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
